import React, { useState, useEffect } from 'react';
import Crud_Catalogos from '../../../../herramientas/Crud_Catalogos';
import './wti-module.css'; // Importar el archivo CSS
import { TablePageablePerRequest } from "../../../../Helpers";
import { TruckLoader } from '../../../../components/loaderTruck/TruckLoader';
import ExcelDownloadLoader from '../../../../components/loaderTruck/ExcelDownloadLoader';
import { LoadingScreen } from '../../../../components/LoadingScreen';


let dateNow = new Date();

const month = dateNow.toLocaleString("default", { month: "2-digit" });

let fechaInicio = `${dateNow.getFullYear()}-${month}-01`;
  
const year = dateNow.toLocaleString("default", { year: "numeric" });
 
const day = dateNow.toLocaleString("default", { day: "2-digit" });



const WTI = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [fechasAplicadas, setFechasAplicadas] = useState({ inicio: '', fin: '' });
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [dateFrom, setDateFrom] = useState(fechaInicio);
  const [dateTo, setDateTo] = useState(year + "-" + month + "-" + day);
   // Estado de tamaño de pagina y pagina actual
  const [pagina,setPagina] =  useState(0);
  const [tamaño,setTamaño]= useState(5);
    //Estado de busqueda
  const [busqueda,setBusqueda] = useState("")
  const [isloaderTable, setisLoaderTable] = useState(true);
  const [movimiento,setMovimiento] =  useState();
  const [dataTaskDownload,setdataTaskDownload] = useState();
  const [isLoadingDates, setIsLoadingDates] = useState(false);


  const currentUser = JSON.parse(sessionStorage.getItem("currentUser"))[0];

  // Cargar datos simulado
  useEffect(() => {

      let url = "";
      url += dateFrom ? "?fechaInicio=" + dateFrom : "?fechaInicio="  
      // Agregar un día a dateTo para la API
      const dateToWithOneDay = dateTo ? new Date(dateTo + 'T00:00:00') : null;
      if (dateToWithOneDay) {
        dateToWithOneDay.setDate(dateToWithOneDay.getDate() + 1);
      }
      url += dateTo ? "&fechaFin=" + dateToWithOneDay.toISOString().split('T')[0] : "&fechaFin="; 
      url += busqueda ? "&movimiento=" + busqueda : "&movimiento=";
      if(dateFrom != '' && dateTo != '' && (busqueda == null || busqueda =="")){
        Crud_Catalogos(
                      "wti/obtieneMovimientos/" + currentUser.plataforma.id + url + "&page=" + ( pagina == 0 ? pagina : pagina -1)  +"&size=" + tamaño ,
                      "",
                      "get",
                      "",
                      )
                      .then((returnVal) => {
                      returnVal.currentPage =  returnVal.number
                      setServices(returnVal);
                      setLoading(false)
                      setisLoaderTable(false);
                    
              });
      }else if(busqueda !=null){
      let url = "";
      url += "?fechaInicio="  
      url += "&fechaFin="; 
      url += busqueda ? "&movimiento=" + busqueda : "&movimiento=";
      Crud_Catalogos(
                            "wti/obtieneMovimientos/" + currentUser.plataforma.id + url + "&page=" + ( pagina == 0 ? pagina : pagina -1)  +"&size=" + tamaño ,
                            "",
                            "get",
                            "",
                            )
                            .then((returnVal) => {
                            returnVal.currentPage =  returnVal.number
                            setServices(returnVal);
                            setLoading(false)
                            setisLoaderTable(false);
                          
                    });
      }
   
  }, [dateFrom,dateTo,pagina,tamaño,busqueda]);

    const downloadExcel =()=>{
    let idPlataforma =  currentUser.plataforma.id ;
        let url = ''; 
        url += dateFrom ? "&fechaInicio=" + dateFrom : "&fechaInicio="  
        // Agregar un día a dateTo para la API de descarga
        const dateToWithOneDay = dateTo ? new Date(dateTo + 'T00:00:00') : null;
        if (dateToWithOneDay) {
          dateToWithOneDay.setDate(dateToWithOneDay.getDate() + 1);
        }
        url += dateTo ? "&fechaFin=" + dateToWithOneDay.toISOString().split('T')[0] : "&fechaFin="; 
        url += busqueda ? "&movimiento=" + busqueda : "&movimiento=";

        if(true){
            Crud_Catalogos("wti/download/start?plataforma="+ idPlataforma+ url,"","get","").then((returnVal) => {
                   setdataTaskDownload(returnVal)
                  
            });
        }
      
  }


    // Aplicar filtro de fechas
  const aplicarFiltroFechas = () => {
    setisLoading(true);
    setPagina(0)
    setLoaderGraficas(true);
    setFechasAplicadas({
      inicio: dateFrom,
      fin: dateTo
    });
  };

  const changePage = (page)=>{
      setisLoaderTable(true);
      setPagina(page)
  }

  const buscarMov=(busqueda)=>{
       setBusqueda(busqueda)
       setPagina(0);
  }

  const changeTamaño = (nuevoTamaño) => { 
        setTamaño(nuevoTamaño);
  };

  const resetDownload= ()=>{
    setdataTaskDownload(null);
  }


  const obtenerColumnas=()=>{
  
      let columnas = ["idMovimiento","tiempo","cliente","transportista","Severidad","Fechas"]
      let columnasTemp= [];
      for(let c of columnas){    
        switch (c) {       
       
          case "Severidad":
            columnasTemp.push({ columna: c, label: c,
              form: (e)=>{

                if(e["tipoMovimiento"] == "Exportación" || e["tipoMovimiento"] == "Exportación Local"){
                  const tiempoCarga =  e.tiempoCarga 
                //   if(tiempoCarga < 0){
                //     return  <div className={`wti-severity-badge wti-severity-badge--na`}>
                //                 {getSeverityLabel("na")}
                //            </div>
                // }
                  
                  
                  if(tiempoCarga <=12){
                    return  <div className={`wti-severity-badge wti-severity-badge--low`}>
                                {getSeverityLabel("low")}
                           </div>
                  }
                  // if(tiempoCarga > 2 && tiempoCarga<= 4){

                  //   return  <div className={`wti-severity-badge wti-severity-badge--medium`}>
                  //               {getSeverityLabel("medium")}
                  //          </div>
                  // }
                  if(tiempoCarga > 12){

                    return  <div className={`wti-severity-badge wti-severity-badge--high`}>
                                {getSeverityLabel("high")}
                           </div>
                  }
                }else if(e["tipoMovimiento"] == "Importación" || e["tipoMovimiento"] == "Importación Local"){
                  const tiempoDescarga =  e.tiempoDescarga 
                  // if(tiempoDescarga < 0){
                  //   return  <div className={`wti-severity-badge wti-severity-badge--na`}>
                  //               {getSeverityLabel("na")}
                  //          </div>
                  // }
                  
                   if(tiempoDescarga <=12){

                    return  <div className={`wti-severity-badge wti-severity-badge--low`}>
                                {getSeverityLabel("low")}
                           </div>
                   }
                  //  if(tiempoDescarga > 2 && tiempoDescarga <= 4){

                  //   return  <div className={`wti-severity-badge wti-severity-badge--medium`}>
                  //               {getSeverityLabel("medium")}
                  //          </div>
                  //  }
                   if(tiempoDescarga > 12){

                    return  <div className={`wti-severity-badge wti-severity-badge--high`}>
                                {getSeverityLabel("high")}
                           </div>
                   }
                }
              }
            });
            break;
  
          case "tiempo":
            columnasTemp.push({ columna: c, label: "Tiempo Excedente",
              form: (e)=>{
                const tiempo = e["tipoMovimiento"] == "Exportación" || e["tipoMovimiento"] == "Exportación Local" ? e.tiempoCarga : e.tiempoDescarga;
                const isExceeded = tiempo > 12;
                
                return (
                  <div className="wti-time-compact">
                    <span className={`wti-time-value-small ${isExceeded ? 'wti-time-exceeded' : ''}`}>
                      {tiempo}h
                    </span>
                    <div className="wti-progress-mini">
                      <div 
                        className={`wti-progress-fill-mini ${isExceeded ? 'wti-progress-exceeded' : ''}`}
                        style={{ width: `${Math.min((tiempo / 12) * 100, 100)}%` }}
                      ></div>
                    </div>
                  </div>
                );
              }});
          
            break;
  
          case "idMovimiento":
            columnasTemp.push({ columna: c, label: "Movimiento",
              form: (e)=> 
                      
                      
                        <div className="wti-service-info">
                           <div className={`wti-movement-icon ${
                              e.tipoMovimiento === 'Importación' ? 'wti-movement-icon--impo' : 'wti-movement-icon--expo'
                           }`}>
                             {e.tipoMovimiento === 'Importación' ? '🚢' : '🚛'}
                           </div>
                           <div className="wti-service-details">
                             <div className="wti-service-id"><span>ID: </span>{e.idMovimiento}</div>
                             <div className="wti-service-week"><span>SO: </span>{e.so}</div>
                             <div className="wti-service-container"><span>Contenedor: </span>{e.contenedor}</div>
                             <div className="wti-service-container"><span>BL: </span>{e.bl}</div>
                           </div>

                       </div>
                        
                           

              });
            // columnasTemp.push({ columna: c.columna, label: c.label,
            //   form: (e)=> [1,3].includes(e[c.columna])? e.destino: e.idCorredor.nombre });
          break;
    
          case "citaProgramada":
            columnasTemp.push({ columna: c.columna, label: "citaProgramada",
              form: (e)=>{
                if( c.idFuncionalidad === 2891 && (e.idMovimientoTipo.id === 1 || e.idMovimientoTipo.id === 304) ){//ultima milla
                  return e.citaProgramada;
                }else{
                  if( c.idFuncionalidad === 2892 && (e.idMovimientoTipo.id === 2 || e.idMovimientoTipo.id === 303) ){//ultima milla
                    return e.citaProgramada;
                  }
                  return e.citaProgramada
                }
              },
              valor: (e)=>{
                if( c.idFuncionalidad === 2891 && (e.idMovimientoTipo.id === 1 || e.idMovimientoTipo.id === 304) ){//ultima milla
                  return e.citaProgramada;
                }else{
                  if( c.idFuncionalidad === 2892 && (e.idMovimientoTipo.id === 2 || e.idMovimientoTipo.id === 303) ){//ultima milla
                    return e.citaProgramada;
                  }
                  return e.citaProgramada
                }
              }
            });
            break;
      
     
          case "Semana":
  
          columnasTemp.push({ columna: c, label: "Semana",
            form: (e)=> e.semana});
          break;
          case "cliente":
          columnasTemp.push({ columna: c, label: "Cliente",
            form: (e)=> e.cliente});
          break;
          case "Fechas":
          columnasTemp.push({ columna: c, label: "Fechas",
            form: (e)=> 
            
            <div className="wti-dates-compact">
                <div className="wti-date-item">
                  <span className="wti-date-icon">📅</span>
                  <span className="wti-date-text">{formatDateTime(e.citaProgramada)}</span>
                </div>
                <div className="wti-date-item">
                  <span className="wti-date-icon wti-date-icon--reversed">🚚</span>
                  <span className="wti-date-text">{formatDateTime(e.llegadaCliente)}</span>
                </div>

                <div className="wti-date-item">
                  <span className="wti-date-icon">🚚</span>
                  <span className="wti-date-text">{formatDateTime(e.salidaCliente)}</span>
                </div>
            </div>
            
            });
          break;
   
          case "Detalle":
            columnasTemp.push({ columna: c.columna, label: "Transportista",
              enClickDisabled: false,
              form: (e)=> e.transportista
            
              }
            
             );
            break;
       
            case "registroOperador":
              columnasTemp.push({ columna: c.columna, label: c.label,
                form: (e)=>{
                  return <ModalLayout 
                    tamanio={'80%'} 
                    title="Movimiento"
                    name={<span><Icon prefix="fa" name="bullhorn" /></span>}
                    hiddenModal={this.state.hiddenModals} 
                    Fclose={this.hiddenmodal}
                    formulario={
                      <OperadoresNavieros
                          data = {e}
                          accion="modificar"
                          usuario={user}
                          getfuntion={this.getfuntion}
                          stor={this.props}
                          elementos= {this.state.elementosSinfiltrar}
                          closeModal={this.hiddenmodal}
                          readonly={this.state.readonly}
                          updateData = {this.updateData}
                       />  
                    }
                  />
                },
              });
              break;
        
          default: columnasTemp.push({ columna: c, label: c });
            break;
        }
      }
      return columnasTemp;
    }

  // Filtrar servicios (sin paginación)
  // const filteredServices = services.filter(service => {
  //   // Filtro de búsqueda
  //   const matchesSearch = searchTerm === '' || 
  //     service.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     service.client.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     service.container.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     service.operator.toLowerCase().includes(searchTerm.toLowerCase());

  //   // Filtro por fecha
  //   const serviceDate = new Date(service.citaProgramada).toISOString().split(' ')[0];
  //   const matchesDateFrom = dateFrom === '' || serviceDate >= dateFrom;
  //   const matchesDateTo = dateTo === '' || serviceDate <= dateTo;

    
  //   return matchesSearch && matchesDateFrom && matchesDateTo;
  // });

  // Cálculos de paginación
  // const totalItems = filteredServices.length;
  // const totalPages = Math.ceil(totalItems / itemsPerPage);
  // const startIndex = (currentPage - 1) * itemsPerPage;
  // const endIndex = startIndex + itemsPerPage;
  // const paginatedServices = filteredServices.slice(startIndex, endIndex);

  // Resetear página cuando cambian los filtros
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, dateFrom, dateTo, itemsPerPage]);

  const formatDateTime = (dateString) => {
    return new Date(dateString).toLocaleString('es-MX', {
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  };

  const getSeverityColor = (severity) => {
    const colors = {
      high: 'bg-red-100 text-red-800 border-red-300',
      medium: 'bg-yellow-100 text-yellow-800 border-yellow-300',
      low: 'bg-green-100 text-green-800 border-green-300'
    };
    return colors[severity] || 'bg-gray-100 text-gray-800 border-gray-300';
  };

  const getSeverityLabel = (severity) => {
    const labels = { high: 'ALTA', medium: 'BAJA', low: 'BAJA' ,na: 'Sin estadia'};
    return labels[severity] || 'DESCONOCIDA';
  };

  // Función para generar números de página visibles
  const getVisiblePages = () => {
    const delta = 2;
    const range = [];
    const rangeWithDots = [];

    for (let i = Math.max(2, currentPage - delta); i <= Math.min(totalPages - 1, currentPage + delta); i++) {
      range.push(i);
    }

    if (currentPage - delta > 2) {
      rangeWithDots.push(1, '...');
    } else {
      rangeWithDots.push(1);
    }

    rangeWithDots.push(...range);

    if (currentPage + delta < totalPages - 1) {
      rangeWithDots.push('...', totalPages);
    } else if (totalPages > 1) {
      rangeWithDots.push(totalPages);
    }

    return rangeWithDots;
  };

  if (loading) {
    return (
      <div className="wti-loading">
        <div className="wti-loading-content">
          <div className="wti-loading-spinner"></div>
          <p className="wti-loading-text">Cargando módulo WTI...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="wti-container">
      <div className="wti-main">
        {/* Header */}
        <div className="wti-header">
          <div className="wti-header-content">
            <div>
              <h1 className="wti-title">
                Módulo WTI - Control Operativo
              </h1>
              <p className="wti-subtitle">
                Naviera {currentUser.plataforma.nombre} • Análisis de tiempos de espera
              </p>
            </div>
            <div className="wti-stats">
              <div className="wti-stat-card wti-stat-card--primary">
                <div className="wti-stat-value">{services.totalElements}</div>
                <div className="wti-stat-label">Servicios</div>
              </div>
              
            </div>
          </div>

          {/* Filtros y controles */}
          <div className="wti-filters">
        
            {/* Selector de rango de fechas */}
            <div className="wti-date-panel">
              <div className="wti-date-header">
                <h3 className="wti-date-title">
                  📅 Filtrar por periodo
                </h3>
                {(dateFrom || dateTo) && (
                  <button
                    onClick={() => {
                      setDateFrom('');
                      setDateTo('');
                    }}
                    className="wti-clear-dates-btn"
                  >
                    ✖️ Limpiar fechas
                  </button>
                )}
              </div>

              <div className="wti-date-inputs">
                {/* Fecha desde */}
                <div className="wti-date-card">
                  <div className="wti-date-card-inner">
                    <div className="wti-date-card-content">
                      <div className="wti-date-icon wti-date-icon--start">
                        <span>📆</span>
                      </div>
                      <div className="wti-date-input-group">
                        <label className="wti-input-label">
                          Fecha de inicio
                        </label>
                        <input
                          type="date"
                          className="wti-date-input"
                          value={dateFrom}
                          onChange={(e) => {
                            setIsLoadingDates(true);
                            setDateFrom(e.target.value);
                            setTimeout(() => setIsLoadingDates(false), 1000);
                          }}
                        />
                        {dateFrom && (
                          <p className="wti-date-preview wti-date-preview--start">
                            {new Date(dateFrom).toLocaleDateString('es-MX', { 
                              weekday: 'short', 
                              month: 'short', 
                              day: 'numeric',
                              year: 'numeric'
                            })}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Fecha hasta */}
                <div className="wti-date-card">
                  <div className="wti-date-card-inner">
                    <div className="wti-date-card-content">
                      <div className="wti-date-icon wti-date-icon--end">
                        <span>📅</span>
                      </div>
                      <div className="wti-date-input-group">
                        <label className="wti-input-label">
                          Fecha de fin
                        </label>
                        <input
                          type="date"
                          className="wti-date-input"
                          value={dateTo}
                          onChange={(e) => {
                            setIsLoadingDates(true);
                            setDateTo(e.target.value);
                            setTimeout(() => setIsLoadingDates(false), 1000);
                          }}
                          min={dateFrom || undefined}
                        />
                        {dateTo && (
                          <p className="wti-date-preview wti-date-preview--end">
                            {new Date(dateTo).toLocaleDateString('es-MX', { 
                              weekday: 'short', 
                              month: 'short', 
                              day: 'numeric',
                              year: 'numeric'
                            })}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Indicador de rango seleccionado */}
              {dateFrom && dateTo && (
                <div className="wti-range-indicator wti-slide-down">
                  <div className="wti-range-content">
                    <div className="wti-range-date">
                      <div className="wti-range-date-label">Desde</div>
                      <div className="wti-range-date-value wti-range-date-value--start">
                        {new Date(dateFrom).toLocaleDateString('es-MX', { 
                          day: '2-digit', 
                          month: 'short' 
                        })}
                      </div>
                    </div>
                    <div className="wti-range-connector">
                      <div className="wti-range-line"></div>
                      <div className="wti-range-dot"></div>
                      <div className="wti-range-line"></div>
                    </div>
                    <div className="wti-range-date">
                      <div className="wti-range-date-label">Hasta</div>
                      <div className="wti-range-date-value wti-range-date-value--end">
                        {new Date(dateTo).toLocaleDateString('es-MX', { 
                          day: '2-digit', 
                          month: 'short' 
                        })}
                      </div>
                    </div>
                    <div className="wti-range-days">
                      <div className="wti-range-days-label">Días</div>
                      <div className="wti-range-days-value">
                        {Math.ceil((new Date(dateTo) - new Date(dateFrom)) / (1000 * 60 * 60 * 24)) + 1}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Sugerencias de rangos rápidos */}
              <div className="wti-quick-ranges">
                <span className="wti-quick-ranges-label">Rangos rápidos:</span>
                <button
                  onClick={() => {
                    setIsLoadingDates(true);
                    const today = new Date();
                    const weekAgo = new Date(today);
                    weekAgo.setDate(today.getDate() - 7);
                    setDateFrom(weekAgo.toISOString().split('T')[0]);
                    setDateTo(today.toISOString().split('T')[0]);
                    setTimeout(() => setIsLoadingDates(false), 1000);
                  }}
                  className="wti-quick-range-btn wti-quick-range-btn--week"
                >
                  Última semana
                </button>
                <button
                  onClick={() => {
                    setIsLoadingDates(true);
                    const today = new Date();
                    const monthAgo = new Date(today);
                    monthAgo.setMonth(today.getMonth() - 1);
                    setDateFrom(monthAgo.toISOString().split('T')[0]);
                    setDateTo(today.toISOString().split('T')[0]);
                    setTimeout(() => setIsLoadingDates(false), 1000);
                  }}
                  className="wti-quick-range-btn wti-quick-range-btn--month"
                >
                  Último mes
                </button>
                <button
                  onClick={() => {
                    setIsLoadingDates(true);
                    const today = new Date();
                    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                    setDateFrom(firstDay.toISOString().split('T')[0]);
                    setDateTo(today.toISOString().split('T')[0]);
                    setTimeout(() => setIsLoadingDates(false), 1000);
                  }}
                  className="wti-quick-range-btn wti-quick-range-btn--current"
                >
                  Este mes
                </button>
              </div>
            </div>
          </div>

          {/* Botones de acción */}
          <div className="wti-actions">
            <div className="wti-services-counter">
              <div className="wti-services-counter-number">
                {services.numberOfElements} de {services.totalElements}
              </div>
              <div className="wti-services-counter-label">
                servicios mostrados
              </div>
            </div>
          </div>
        </div>

        {/* Contenido - Solo Tabla */}
        {services.length === 0 ? (
          <div className="wti-empty-state wti-fade-in">
            <div className="wti-empty-icon">📊</div>
            <h3 className="wti-empty-title">
              No se encontraron servicios
            </h3>
            <p className="wti-empty-description">
              Intenta con otros criterios de búsqueda o filtros
            </p>
          </div>
        ) : (

                    <TablePageablePerRequest            
                      titulo={<h3> Movimientos </h3>}
                      listaTemp={ services }
                      columnas={ obtenerColumnas()
                 
                      }
                      hook={changePage}
                      hookTotalByPage={changeTamaño}
                      elementosPorPagina={tamaño}
                      CSVDownload={downloadExcel}
                      id="id"
                      selected={(e) => setMovimiento(e)} 
                      csvname="Solicitudes"
                      busquedaHook={buscarMov}
                      loader={ <TruckLoader 
                        isLoading={isloaderTable} 
                        message="Cargando datos de la tabla..."
                      />}
                      // resaltarFuncion={(e)=> !e.idMovimiento? true: false}
                      //resaltarColor={"rgba(223, 58, 58, 0.47)"}
                    />
              
                    
          // <div className="wti-table-container wti-fade-in">
          //   <div className="wti-table">
          //     <table>
          //       <thead className="wti-table-header">
          //         <tr>
          //           <th>Servicio</th>
          //           <th>Fecha de Cita</th>
          //           <th>Cliente/Ubicación</th>
          //           <th>Tiempos</th>
          //           <th>Horas Excedidas</th>
          //           <th>Severidad</th>
          //         </tr>
          //       </thead>
          //       <tbody className="wti-table-body">
          //         {paginatedServices.map((service, index) => (
          //           <tr key={service.id} className="wti-table-row">
          //             <td className="wti-table-cell">
          //               <div className="wti-service-info">
          //                 <div className={`wti-movement-icon ${
          //                   service.movementType === 'impo' ? 'wti-movement-icon--impo' : 'wti-movement-icon--expo'
          //                 }`}>
          //                   {service.movementType === 'impo' ? '🚢' : '🚛'}
          //                 </div>
          //                 <div className="wti-service-details">
          //                   <div className="wti-service-id">{service.id}</div>
          //                   <div className="wti-service-week">{service.week}</div>
          //                   <div className="wti-service-container">{service.container}</div>
          //                 </div>
          //               </div>
          //             </td>
          //             <td className="wti-table-cell">
          //               <div className="wti-date-info">
          //                 <div className="wti-date-main">
          //                   {new Date(service.appointmentTime).toLocaleDateString('es-MX', {
          //                     weekday: 'short',
          //                     year: 'numeric',
          //                     month: 'short',
          //                     day: 'numeric'
          //                   })}
          //                 </div>
          //                 <div className="wti-date-time">
          //                   {formatDateTime(service.appointmentTime)}
          //                 </div>
          //               </div>
          //             </td>
          //             <td className="wti-table-cell">
          //               <div className="wti-client-info">
          //                 <div className="wti-client-name">{service.client}</div>
          //                 <div className="wti-client-location">{service.location}</div>
          //                 <div className="wti-client-operator">{service.operator} • {service.vehicle}</div>
          //               </div>
          //             </td>
          //             <td className="wti-table-cell">
          //               <div className="wti-times-info">
          //                 <div className="wti-time-row"><span className="wti-time-label">Cita:</span> {formatDateTime(service.appointmentTime)}</div>
          //                 <div className="wti-time-row"><span className="wti-time-label">Llegada:</span> {formatDateTime(service.arrivalTime)}</div>
          //                 <div className="wti-time-row"><span className="wti-time-label">Fin:</span> {formatDateTime(service.serviceEndTime)}</div>
          //               </div>
          //             </td>
          //             <td className="wti-table-cell">
          //               <div className="wti-exceeded-hours">
          //                 <div className="wti-hours-main">{service.exceededHours}h</div>
          //                 <div className="wti-hours-total">de {(service.exceededHours + 8).toFixed(1)}h total</div>
          //                 <div className="wti-progress-bar">
          //                   <div 
          //                     className="wti-progress-fill" 
          //                     style={{ width: `${Math.min((service.exceededHours / 8) * 100, 100)}%` }}
          //                   ></div>
          //                 </div>
          //               </div>
          //             </td>
          //             <td className="wti-table-cell">
          //               <div className={`wti-severity-badge wti-severity-badge--${service.severity}`}>
          //                 {getSeverityLabel(service.severity)}
          //               </div>
          //             </td>
          //           </tr>
          //         ))}
          //       </tbody>
          //     </table>
          //   </div>
            
          //   {/* Footer de la tabla con totales (solo servicios filtrados) */}
          //   <div className="wti-table-footer">
          //     <div className="wti-footer-content">
          //       <div className="wti-footer-count">
          //         Total servicios filtrados: {filteredServices.length}
          //       </div>
          //       <div className="wti-footer-stats">
          //         <div className="wti-footer-stat-total">
          //           <span className="wti-footer-stat-label">Total excedido:</span> {filteredServices.reduce((acc, s) => acc + s.exceededHours, 0).toFixed(1)}h
          //         </div>
          //         <div className="wti-footer-stat-average">
          //           <span className="wti-footer-stat-label">Promedio:</span> {filteredServices.length > 0 ? (filteredServices.reduce((acc, s) => acc + s.exceededHours, 0) / filteredServices.length).toFixed(1) : 0}h
          //         </div>
          //       </div>
          //     </div>
          //   </div>

          //   {/* Componente de paginación */}
          //   <PaginationComponent />
          // </div>
        )}

        {/* Footer informativo */}
        <div className="wti-info-footer">
          <div className="wti-info-grid">
            <div className="wti-info-section">
              <h3 className="wti-info-title">
                ⏰ Reglas Operativas
              </h3>
              <div className="wti-info-list">
                <div className="wti-info-item">• <span className="wti-info-item-label">Tiempo libre:</span> 12 horas de carga/descarga</div>
                <div className="wti-info-item">• <span className="wti-info-item-label">Tolerancia:</span> 1 hora después de la cita</div>
                <div className="wti-info-item">• <span className="wti-info-item-label">Inicio de conteo:</span> Desde hora de cita</div>
                <div className="wti-info-item">• <span className="wti-info-item-label">Exclusiones:</span> Llegadas +1h tarde</div>
              </div>
            </div>
            <div className="wti-info-section">
              <h3 className="wti-info-title">
                📅 Iconos de Fechas
              </h3>
              <div className="wti-info-list">
                <div className="wti-info-item">📅 <span className="wti-info-item-label">Calendario:</span> Cita programada</div>
                <div className="wti-info-item"> <span className='wti-date-icon--reversed'> 🚚</span> <span className="wti-info-item-label ">Camión →:</span> Llegada del cliente</div>
                <div className="wti-info-item">🚚 <span className="wti-info-item-label">Camión ←:</span> Salida del cliente</div>
              </div>
            </div>
            <div className="wti-info-section">
              <h3 className="wti-info-title">
                🚛 Tipos de Movimiento
              </h3>
              <div className="wti-info-list">
                <div className="wti-info-item">
                  <div className="wti-movement-icon wti-movement-icon--impo" style={{width: '1rem', height: '1rem', fontSize: '0.75rem', marginRight: '0.5rem'}}>🚢</div>
                  <span className="wti-info-item-label">Barco (Morado):</span> Exportación
                </div>
                <div className="wti-info-item">
                  <div className="wti-movement-icon wti-movement-icon--expo" style={{width: '1rem', height: '1rem', fontSize: '0.75rem', marginRight: '0.5rem'}}>🚛</div>
                  <span className="wti-info-item-label">Camión (Verde):</span> Importación
                </div>
              </div>
            </div>
            <div className="wti-info-section">
              <h3 className="wti-info-title">
                ⚠️ Niveles de Severidad
              </h3>
              <div className="wti-info-list">
                <div className="wti-info-item">
                  <div className="wti-info-item-bullet wti-info-item-bullet--high"></div>
                  <span className="wti-info-item-label">ALTA:</span> Más de 12 horas excedidas
                </div>
                {/* <div className="wti-info-item">
                  <div className="wti-info-item-bullet wti-info-item-bullet--medium"></div>
                  <span className="wti-info-item-label">MEDIA:</span> Entre 2 y 4 horas excedidas
                </div> */}
                <div className="wti-info-item">
                  <div className="wti-info-item-bullet wti-info-item-bullet--low"></div>
                  <span className="wti-info-item-label">BAJA:</span> Menos de 12 horas excedidas
                </div>
                {/* <div className="wti-info-item">
                  <div className="wti-info-item-bullet wti-info-item-bullet--na"></div>
                  <span className="wti-info-item-label">SIN ESTADIA:</span> Menos de 0 horas
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <>
                        {dataTaskDownload?.status ?
                        <ExcelDownloadLoader  data={dataTaskDownload} reset={resetDownload}></ExcelDownloadLoader>
                            :null}
                        </>
      
      <LoadingScreen loading={isLoadingDates} />
    </div>
    
  );
};

export default WTI;